export default (number = 0) => {
  const thousand = new Intl.NumberFormat('id-ID')
  return thousand.format(number)
}
